import i18n from "../../../i18n";

export const usersField = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "email",
        label: i18n.t("users.emailAddress"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "roles",
        label: i18n.t("users.role"),
        sortable: true,
        sortDirection: "desc",
        formatter: formatRoles
    },
    {
        key: "impersonation",
        label: i18n.t("users.impersonate")
    },
    {
        key: "actions",
        label: ""
    }
];

// Returns roles in a sorted, comma seperated string
function formatRoles(roles: string[]) {
    return [...roles].sort((a, b) => a.localeCompare(b)).join(", ");
}
